import React from 'react';
import { Icon } from './Icon.js';
export const IconLabel3Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M13.883,3.648c-.334-.412-.83-.648-1.36-.648H4.75c-1.517,0-2.75,1.233-2.75,2.75v6.5c0,1.517,1.233,2.75,2.75,2.75h7.773c.53,0,1.026-.236,1.36-.649l3.95-4.879c.223-.275,.223-.668,0-.943l-3.95-4.88Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconLabel3Fill18.js.map